const createNewBrandTooltip = 'This will redirect you to your connection page.'
const createNewRetailerTooltip = 'This will redirect you to your profile page.'
const brandBillingCodeCaption =
  'Billing Code can only be updated from your Connections page.'
const retailerBillingCodeCaption =
  'Billing Code can only be updated by the brand.'
const brandShippingCodeCaption =
  'Shipping Code can only be updated from your Connections page.'
const retailerShippingCodeCaption =
  'Shipping Code can only be updated by the brand.'

export const messages = {
  selectAddress: 'Select Address',
  clearAllFields: 'Clear All Fields',
  storeName: 'Store Name',
  officeName: 'Office Name',
  address1: 'Address 1',
  address2: 'Address 2',
  city: 'City',
  country: 'Country',
  email: 'Email',
  door: 'Door',
  shippingCode: 'Shipping Code',
  shippingMethod: 'Shipping Method',
  phone: 'Phone',
  billingCode: 'Billing Code',
  paymentMethod: 'Payment Method',
  state: 'State',
  territory: 'Territory',
  zipCode: 'Zip Code',
  postalCode: 'Postal Code',
  createNew: 'Create New',
  trackingNumber: 'Tracking Number',
  shippingInfo: 'Shipping Info',
  billingInfo: 'Billing Info',
  warningText:
    'You are restricted from editing address information. Please reach out to the brand directly',
  shippingAndBilling: 'Shipping and Billing',
  shipping: 'Shipping',
  billing: 'Billing',
  getShippingCodeCaption: (isAccountTypeBrand: boolean) =>
    isAccountTypeBrand ? brandShippingCodeCaption : retailerShippingCodeCaption,
  getBillingCodeCaption: (isAccountTypeBrand: boolean) =>
    isAccountTypeBrand ? brandBillingCodeCaption : retailerBillingCodeCaption,
  getTaxLabel: (label?: string | null) => `${label ?? 'Tax'} ID`,
  getCreateNewTooltip: (isAccountTypeBrand: boolean) =>
    isAccountTypeBrand ? createNewBrandTooltip : createNewRetailerTooltip,
} as const
